"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_SYSTEM_ELEMENTS = exports.SYSTEM_DYNAMIC_ELEMENT_USER_MOBILE_OS = exports.SYSTEM_DYNAMIC_ELEMENT_USER_DEVICE_TYPE = exports.SYSTEM_DYNAMIC_ELEMENT_NOW = void 0;
const dynamicElement_1 = require("./dynamicElement");
const logicTypes_1 = require("./logicTypes");
const NO_TRANSFORMATIONS = [];
exports.SYSTEM_DYNAMIC_ELEMENT_NOW = new dynamicElement_1.DynamicElement(null, {
    name: logicTypes_1.LogicType.SYS_ELEMENT_NOW,
    type: dynamicElement_1.ElementType.NUMBER
}, null, NO_TRANSFORMATIONS, { localId: "localId-system-element-now" }, {
    type: logicTypes_1.LogicType.SYS_ELEMENT_NOW
});
exports.SYSTEM_DYNAMIC_ELEMENT_USER_DEVICE_TYPE = new dynamicElement_1.DynamicElement(null, {
    name: logicTypes_1.LogicType.SYS_ELEMENT_VIEWER_DEVICE,
    type: dynamicElement_1.ElementType.STRING
}, [
    {
        id: "viewer_device_mobile",
        dn: "Mobile"
    },
    {
        id: "viewer_device_desktop",
        dn: "Desktop"
    }
], NO_TRANSFORMATIONS, { localId: "localId-system-element-user-device-type" }, {
    type: logicTypes_1.LogicType.SYS_ELEMENT_VIEWER_DEVICE
});
exports.SYSTEM_DYNAMIC_ELEMENT_USER_MOBILE_OS = new dynamicElement_1.DynamicElement(null, {
    name: logicTypes_1.LogicType.SYS_ELEMENT_VIEWER_MOBILE_DEVICE_OS,
    type: dynamicElement_1.ElementType.STRING
}, [
    {
        id: "mobile_os_ios",
        dn: "iOS"
    },
    {
        id: "mobile_os_android",
        dn: "Android"
    },
    {
        id: "mobile_os_other",
        dn: "Other"
    }
], NO_TRANSFORMATIONS, { localId: "localId-system-element-user-mobile-os" }, {
    type: logicTypes_1.LogicType.SYS_ELEMENT_VIEWER_MOBILE_DEVICE_OS
});
/**
 * All the available system dynamic elements
 */
exports.ALL_SYSTEM_ELEMENTS = [
    exports.SYSTEM_DYNAMIC_ELEMENT_USER_DEVICE_TYPE,
    exports.SYSTEM_DYNAMIC_ELEMENT_USER_MOBILE_OS
];
//# sourceMappingURL=systemElements.js.map